var _rect, _path, _path2, _circle, _rect2, _path3, _path4, _circle2, _rect3, _path5, _path6, _circle3, _rect4, _path7, _rect5, _path8, _rect6, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceCreativeArts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 145,
    viewBox: "0 0 296 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 39,
    width: 64,
    height: 64,
    rx: 9.84615,
    fill: "#312FCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9468 74.3322L69.7446 86.1301C70.52 86.9054 69.9709 88.2311 68.8744 88.2311H45.2786C44.1821 88.2311 43.633 86.9054 44.4083 86.1301L56.2062 74.3322C56.6868 73.8516 57.4661 73.8516 57.9468 74.3322Z",
    fill: "#FD6E3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7161 69.4084L57.437 86.1293C58.2124 86.9047 57.6632 88.2304 56.5667 88.2304H23.1248C22.0283 88.2304 21.4792 86.9047 22.2545 86.1293L38.9755 69.4084C39.4561 68.9277 40.2354 68.9277 40.7161 69.4084Z",
    fill: "#FD6E3B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.1538,
    cy: 58.0767,
    r: 6.15385,
    fill: "#F6C630"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 39,
    width: 64,
    height: 64,
    rx: 9.84615,
    fill: "#312FCA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.947 74.3322L165.745 86.1301C166.52 86.9054 165.971 88.2311 164.874 88.2311H141.279C140.182 88.2311 139.633 86.9054 140.408 86.1301L152.206 74.3322C152.687 73.8516 153.466 73.8516 153.947 74.3322Z",
    fill: "#FD6E3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.716 69.4084L153.437 86.1293C154.212 86.9047 153.663 88.2304 152.567 88.2304H119.125C118.028 88.2304 117.479 86.9047 118.255 86.1293L134.975 69.4084C135.456 68.9277 136.235 68.9277 136.716 69.4084Z",
    fill: "#FD6E3B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.154,
    cy: 58.0767,
    r: 6.15385,
    fill: "#F6C630"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 31,
    width: 80,
    height: 80,
    rx: 12.3077,
    fill: "#312FCA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M252.934 75.165L267.681 89.9124C268.65 90.8815 267.964 92.5387 266.593 92.5387H237.099C235.728 92.5387 235.042 90.8815 236.011 89.9124L250.758 75.165C251.359 74.5642 252.333 74.5642 252.934 75.165Z",
    fill: "#FD6E3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M231.395 69.0107L252.297 89.9119C253.266 90.8811 252.579 92.5382 251.209 92.5382H209.406C208.036 92.5382 207.349 90.8811 208.318 89.9119L229.22 69.0107C229.82 68.4099 230.795 68.4099 231.395 69.0107Z",
    fill: "#FD6E3B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.692,
    cy: 54.8466,
    r: 7.69231,
    fill: "#F6C630"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.5 101L170.5 105L177.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 101L74.5 105L81.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 143,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 26,
    r: 2,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 137.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 15.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.5,
    cy: 115.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.5,
    cy: 131.5,
    r: 1.5,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 37.5,
    r: 1.5,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 31.5,
    r: 1.5,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 6.5L202.5 18",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.5 6.5L263 19",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 122.5L196.5 133",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M251 127.5L256.5 142",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceCreativeArts);
export default __webpack_public_path__ + "static/media/persistence-creative-arts.0e693b155228dc4d405bb95d7c75d1bd.svg";
export { ForwardRef as ReactComponent };